/**
 * @file React hook — useFuelMixDropdownOptions.
 * Shared loader for the CMS "Fuel Mix" dropdown options.
 * Used by admin reference-table editors (Characterization factors,
 * Calorific values, Fuel densities) so they all draw from the same list
 * that drives Form A1/A2/A3.
 */

import { useCallback, useEffect, useState } from "react";
import { dropdownService } from "../../../../services/dropdownService";
import type { DropdownOption } from "../../../../interfaces/dropdownInterfaces";

const FUEL_MIX_DROPDOWN_NAME = "Fuel Mix";

/** Hook: use Fuel Mix Dropdown Options. */
export function useFuelMixDropdownOptions(): {
  options: DropdownOption[];
  reload: () => Promise<void>;
} {
  const [options, setOptions] = useState<DropdownOption[]>([]);

  const reload = useCallback(async () => {
    try {
      const dropdowns = await dropdownService.getAll();
      const fuelMix = dropdowns.find(
        (d) => d.name?.trim().toLowerCase() === FUEL_MIX_DROPDOWN_NAME.toLowerCase()
      );
      setOptions(Array.isArray(fuelMix?.options) ? fuelMix!.options : []);
    } catch {
      setOptions([]);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { options, reload };
}
